export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const SET_NEWPASSWORD="SET_NEWPASSWORD"
export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"
export const NEW_PASSWORD_REQUIRED= "NEW_PASSWORD_REQUIRED"
export const SOCIAL_LOGIN = "SOCIAL_LOGIN"
export const NEW_PASSWORD_SESSION_ID= "NEW_PASSWORD_SESSION_ID"
export const GET_ALL_FORMS="GET_ALL_FORMS"
